import { StyledCreateTownhallModal } from "./styledComponents";
import { CreateTownhallModalContent, CreateTownhallModalProps } from "./CreateTownhallModalContent";
import { ButtonAnalyticsProvider } from "@kaltura/mediaspace-shared-hooks";

/**
 * Create Townhall Modal component
 */
export const CreateTownhallModal = (props: CreateTownhallModalProps) => {
    const { mode = "kwebcast", ...formProps } = props;

    return (
        <StyledCreateTownhallModal open={formProps.open} classes={{ paper: "kms-ds-create-townhall-modal" }}>
            <ButtonAnalyticsProvider
                location={mode === "kwebcast" ? "Create Townhall Modal box" : "Create Live studio Modal box"}
            >
                <CreateTownhallModalContent mode={mode} {...formProps} />
            </ButtonAnalyticsProvider>
        </StyledCreateTownhallModal>
    );
};
